<template>
  <div class="editPage">
    <qx-card :title="pageTitle">
      <BaseForm ref="baseForm" />
      <Worker ref="worker" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import Worker from './worker';
import SubBtnBox from 'components/subBtnBox';
import {
  userEdit,
  userDetail,
} from 'api/system';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    Worker,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/system/jurisdiction/worker/edit',
      formComponents: ['baseForm', 'worker'],
      editParams: {
      },

      // 需要对比的参数
      compareParams: {
        lockFlag: '',
        linkman: '',
        identification: '',
        employeeNumber: '',
        staffPosition: '',
        orgIds: '',
        staffNickname: '',
        joinedDate: '',
        employeeAttributes: '',
      },
    };
  },
  computed: {
    detailParams () {
      return {
        userId: this.$route.query.id,
      };
    },
  },
  methods: {
    detailApi: userDetail,
    editApi: userEdit,
  },
  async mounted () {
    await this.$refs.baseForm.getList();
    await this.$refs.worker.getList();
    this.getData();
  },
};
</script>

<style scoped lang="scss">
</style>
